import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';
import toQueryString from '../../lib/toQueryString';

function formatPosition(lat, lng) {
  return "".concat(lat, ",").concat(lng);
}

function formatMarkers(markers) {
  return markers.map(function (_ref) {
    var positions = _ref.positions,
        styles = _ref.styles;
    var markerComponents = []; // Add styles first

    if (styles) {
      Object.entries(styles).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            k = _ref3[0],
            v = _ref3[1];

        markerComponents.push("".concat(k, ":").concat(v));
      });
    } // Add positions


    positions.forEach(function (position) {
      markerComponents.push(formatPosition(position.lat, position.lng));
    }); // Delineate using a pipe character

    return markerComponents.join('|');
  });
}

export default function GoogleMapImage(_ref4) {
  var alt = _ref4.alt,
      apiKey = _ref4.apiKey,
      center = _ref4.center,
      height = _ref4.height,
      lat = _ref4.lat,
      lng = _ref4.lng,
      markers = _ref4.markers,
      width = _ref4.width,
      zoom = _ref4.zoom;
  var host = 'http://maps.googleapis.com/maps/api/staticmap';
  var query = toQueryString({
    center: lat && lng ? formatPosition(lat, lng) : center,
    key: apiKey,
    markers: formatMarkers(markers),
    size: "".concat(width, "x").concat(height),
    zoom: zoom
  });
  return React.createElement(Image, {
    alt: alt,
    src: "".concat(host).concat(query ? "?".concat(query) : '')
  });
}
GoogleMapImage.propTypes = {
  /** Native alt attribute */
  alt: PropTypes.string.isRequired,

  /** Google API key */
  apiKey: PropTypes.string,

  /** Alternative to lat/lng, a string address (e.g. "city hall, new york, ny") */
  center: PropTypes.string,

  /** Height of the produced image */
  height: PropTypes.number,

  /** Center point latitude */
  lat: PropTypes.number,

  /** Center point longitude */
  lng: PropTypes.number,

  /** Array of markers */
  markers: PropTypes.arrayOf(PropTypes.shape({
    positions: PropTypes.arrayOf(PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired
    })),
    styles: PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string,
      size: PropTypes.oneOf(['tiny', 'mid', 'small'])
    })
  })),

  /** Width of the produced image */
  width: PropTypes.number,

  /** Zoom level (0 to 22) */
  zoom: PropTypes.number
};
GoogleMapImage.defaultProps = {
  apiKey: undefined,
  center: undefined,
  height: 300,
  lat: undefined,
  lng: undefined,
  markers: [],
  width: 600,
  zoom: 10
};